// extracted by mini-css-extract-plugin
module.exports = {"container":"_3YxRQ","noSeparators":"_32nEs","section":"_29Euw","socialActions":"_30RfN","mainSection":"MQFQm","bottomSection":"_3iPjK","stats":"_2GSVK","comments":"mFo8P"};